import { useForm, FormProvider } from "react-hook-form";
import SelectDropdown from "../features/header/SelectDropdowns";
import { emailFilter } from "./Constants";

interface EmailFilterDropdownProps {
    mailStatusFilter: { label: string; value: string };
    setMailStatusFilter: (option: { label: string; value: string }) => void;
}

export default function EmailFilterDropdown({
    mailStatusFilter,
    setMailStatusFilter,
}: EmailFilterDropdownProps) {
    const methods = useForm();

    return (
        <FormProvider {...methods}>
            <form className="w-full">
                <SelectDropdown
                    label="Filter App"
                    name="filterApp"
                    options={emailFilter}
                    defaultValue={mailStatusFilter.label}
                    onChange={(value: string) => {
                        const found = emailFilter.find((option) => option.value === value);
                        if (found) {
                            setMailStatusFilter(found);
                        }
                    }}
                    placeHolder="Select Mail Type"
                    isAgent={true}
                />
            </form>
        </FormProvider>
    );
}
